import React, {useState, useEffect, useContext} from 'react'
import axios from 'axios';
import { Button, ButtonGroup, Breadcrumb, Dropdown, Table } from 'react-bootstrap';
import {Modal, ModalBody, ModalHeader, ModalFooter, Alert  } from "react-bootstrap";
import Preloader from "../../components/Preloader/Preloader";
import { ProductContext } from '../../ProductProvider';
import { fetchAuthSession, getCurrentUser, signOut, signIn } from '@aws-amplify/auth';
import ReactToPrint from "react-to-print";
import { CSVLink } from "react-csv";
import { downloadPaymentHeaders } from "../../ProData";
import RegistrationForm from '../Registrations/RegistrationForm';
const config = require('../../config.json');

export default function ListCatalogueRequest(props) {
    const { searchResults} = props;
    const { subscriberDetails, setsubscriberDetails, loggedUser, alertClose, validateLogin, alertDetails, setAlertDetails, generateDate } = useContext(ProductContext);
    const [loaded, setLoaded] = useState(false);
    const [collapsed, setCollapsed] = useState(true);
    //const [searchResults, setSearchResults] = useState([]);
    const csvLinkEl = React.createRef();
    const componentRef = React.useRef(null);

    useEffect(()=>{
        if(loggedUser.isAuthenticated){
          alertClose();
          //console.log("props : ", props);
          //fetchCatalogueRequestDetails();
        }else{
        validateLogin();
        alertClose();
        }
        return()=>{
          alertClose();
        }
    },[])

    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
      }, [componentRef.current]);
    
      const reactToPrintTrigger = React.useCallback(() => {
        return <Button variant="outline-primary"  size="sm">Print</Button>;
      }, []);    

    const toggle = () => {
        setCollapsed(!collapsed);
    }

    const handleApplicationView=async(event, item)=>{
        event.preventDefault();
        //console.log("Item : ", item);
        try{
          setLoaded(false);
  const { idToken } = (await fetchAuthSession()).tokens ?? {};
          const fetchOption="ApplicationID";
          await axios.get(`${config.api.invokeURL}/dashboard/search?fetchOption=${fetchOption}&fetchKey=${item.applicationNo}`,{
            headers: {
              Authorization: idToken,
              'x-api-key': config.api.key
            }}, 
        ).then((response)=>{
          //console.log("Response : ", response.data);
          if(item.avatar===undefined){
            item.avatar="";
          }
          const {applicantName,applicationStatus,applicantEmailID,applicantAreaCode, applicantAddress, applicantContactNo, specialAccess, startDate, endDate, registrationDate, applicationNo }=response.data[0];
          item.applicantName=applicantName;
          item.applicationStatus=applicationStatus;
          item.applicantEmailID=applicantEmailID;
          item.applicantAreaCode=applicantAreaCode;
          item.applicantAddress=applicantAddress;
          item.specialAccess=specialAccess;
          item.applicantContactNo=applicantContactNo;
          item.startDate=startDate;
          item.endDate=endDate;
          item.registrationDate=registrationDate;
          setsubscriberDetails(item);
          toggle();
          //setApplicationDetails(response.data);
            setAlertDetails({
                ...alertDetails,
                style:"success",
                open:true,
                message: applicationNo + " successfully fetched!" 
            });  
            setLoaded(true);
        }).catch((error)=>{
            //console.log(error);
            setAlertDetails({
                ...alertDetails,
                style:"warning",
                open:true,
                message:"Error Occured - " + error.message
            }); 
            setLoaded(true);
            //setDispMsg(error.message);
        })
        }catch(error){
            setAlertDetails({
                ...alertDetails,
                style:"warning",
                open:true,
                message:"Error Occured - " + error.message
            }); 
        }
    }

    const handleCatalogueAction=async(event, tstatus)=>{
        event.preventDefault();
        try{
            const tDate= await generateDate();
  const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const params={
                requestID:subscriberDetails.requestID,
                requestStatus:tstatus,  
                updatedBy:loggedUser.name,
                updatedOn:tDate,
            }
            //console.log("Params : ", params);
            await axios.patch(`${config.api.invokeURL}/catalogue_request`, params,{
                headers: {
                Authorization: idToken,
                'x-api-key':config.api.key
                }})
                .then(async(response)=>{
                //  console.log("Response : ", response);
                //fetchCatalogueRequestDetails();
                setAlertDetails({
                    ...alertDetails,
                    style:"success",
                    open:true,
                    message: subscriberDetails.requestID + " - Successfully Updated!"
                }); 
                toggle();
                window.scrollTo(0,0);
                setLoaded(true);            
                })
                .catch((error)=>{
                    setAlertDetails({
                    ...alertDetails,
                    style:"warning",
                    open:true,
                    message: "Error Occured : " + error.message
                }); 
                window.scrollTo(0,0);
                setLoaded(true);
                })
        }catch(error){
            setAlertDetails({
                ...alertDetails,
                style:"warning",
                open:true,
                message:"Error Occured - " + error.message
            }); 
        }
    }

    const handleDownload =async(event)=>{
        event.preventDefault();
        csvLinkEl.current.link.click();
      }

  return (
  <>
    {/*View*/}
    <Modal onHide={toggle} show={!collapsed} style={{top:'10%'}}>
        <Modal.Header toggle={toggle}>
        </Modal.Header>
        <Modal.Body>    
            <RegistrationForm formType={"ViewReq"}/> 
        </Modal.Body>
        <Modal.Footer>
        {subscriberDetails.requestStatus==="Pending"?<>
        <Button onClick={event=>handleCatalogueAction(event, "Approved")}>
            Approve
        </Button>
        <Button onClick={event=>handleCatalogueAction(event, "Declined")}>
            Declined
        </Button>
        </>:null}
        <Button onClick={toggle}>
            Close
        </Button>
        </Modal.Footer>
    </Modal>
    <Table responsive hover className="user-table align-items-center">
        <thead>
            <tr>
                <th>#</th>
                <th>Request ID</th>
                <th>Subscriber ID</th>
                <th>Requested Date</th>
                <th>Project Title</th>
                <th>Status</th>
               <th>Action</th>
            </tr>
        </thead>
        <tbody>
            {searchResults.map((item, index)=>
            <tr key={index}>
            <th scope="row">{index+1}</th>
            <td>{item.requestID}</td>
            <td>{item.applicationNo}</td>
            <td>{item.requestDate}</td>
            <td>{item.researchProjectTitle}</td>
            <td>{item.requestStatus==="Pending"?<p style={{backgroundColor:"blue", borderRadius:"10px", textAlign:"center", color:"white"}}>{item.requestStatus}</p>:
            item.requestStatus==="Approved"?<p style={{backgroundColor:"green", borderRadius:"10px", textAlign:"center", color:"white"}}>{item.requestStatus}</p>:
            <p style={{backgroundColor:"red", borderRadius:"10px", textAlign:"center", color:"white"}}>{item.requestStatus}</p>}</td>
           <td>
           <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle as={Button} split variant="link" className="text-dark m-0 p-0">
              <span className="icon icon-sm">
                <i className="bi bi-three-dots"></i>
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item  onClick={(event)=>{handleApplicationView(event, item, "View")}}>
                <i className="bi bi-eye"></i> View Details
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
            </td>
            </tr>)}
        </tbody>
    </Table>
  </>
  )
}
